import type { ReactNode } from 'react';

type Tone = 'error' | 'success' | 'info' | 'warning';

/** Signal colours only mean a state (brand/README.md): tinted background, ink text, coloured edge. */
const TONES: Record<Tone, string> = {
  error: 'bg-danger-tint border-danger',
  success: 'bg-success-tint border-success',
  info: 'bg-surface border-control-border',
  warning: 'bg-warning-tint border-warning',
};

export function Alert({ tone = 'info', children }: { tone?: Tone; children: ReactNode }) {
  return (
    <div
      role={tone === 'error' ? 'alert' : 'status'}
      className={`callout rounded-md border-l-4 px-3 py-2 text-ink ${TONES[tone]}`}
    >
      {children}
    </div>
  );
}
